// Quantity selector — +/- buttons
function qtyChange(btn, delta) {
  var input = btn.parentElement.querySelector('.qty-input');
  var val = parseInt(input.value) || 1;
  val = Math.max(1, Math.min(99, val + delta));
  input.value = val;
  updateBuyNowPrice(val);
}

function updateBuyNowPrice(qty) {
  var buyBtn = document.getElementById('buy-now-btn');
  if (!buyBtn) return;
  var unitPrice = parseFloat(buyBtn.dataset.price) || 0;
  var total = (unitPrice * qty).toFixed(2);
  var formatted = buyBtn.dataset.currency === 'USD'
    ? '$' + parseFloat(total).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    : total + ' ' + buyBtn.dataset.currency;
  var priceSpan = document.getElementById('buy-now-price');
  if (priceSpan) priceSpan.textContent = formatted;
}

// Buy Now — add to cart (with quantity) then redirect directly to checkout
function buyNow(btn, variantId, qtyInputId) {
  var qtyInput = qtyInputId ? document.getElementById(qtyInputId) : btn.closest('.qty-row') && btn.closest('.qty-row').querySelector('.qty-input');
  var quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
  var price    = parseFloat(btn.dataset.price) || 0;
  var currency = btn.dataset.currency || 'USD';
  var title    = btn.dataset.title || '';

  var originalText = btn.textContent;
  btn.textContent = 'Processing…';
  btn.disabled = true;
  btn.style.opacity = '0.7';

  fetch('/cart/clear.js', { method: 'POST' })
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
      });
    })
    .then(function() {
      if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart', {
          content_ids: [variantId.toString()],
          content_type: 'product',
          content_name: title,
          value: price * quantity,
          currency: currency,
          num_items: quantity
        });
        fbq('track', 'InitiateCheckout', {
          content_ids: [variantId.toString()],
          content_type: 'product',
          value: price * quantity,
          currency: currency,
          num_items: quantity
        });
      }
      window.location.href = '/checkout';
    })
    .catch(function() {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.style.opacity = '1';
    });
}

// Buy Now for product page — uses variant stored on button (kept current by selectBundle)
function buyNowSelected(btn) {
  var variantId = btn.dataset.variant;
  buyNow(btn, variantId, 'qty-product');
}

// Gallery image switcher
function setImg(thumb, imgUrl) {
  var mainImg = document.getElementById('mainImg');
  if (mainImg) {
    mainImg.style.opacity = '0';
    setTimeout(function() {
      mainImg.src = imgUrl;
      mainImg.style.opacity = '1';
    }, 200);
  }
  document.querySelectorAll('.gallery-thumb').forEach(function(t) {
    t.classList.remove('active');
  });
  thumb.classList.add('active');
}

// Scroll reveal
document.addEventListener('DOMContentLoaded', function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.reveal').forEach(function(el) {
    observer.observe(el);
  });

  // Trigger already-visible elements (above the fold)
  setTimeout(function() {
    document.querySelectorAll('.reveal').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('visible');
      }
    });
  }, 100);

  // Main image transition setup
  var mainImg = document.getElementById('mainImg');
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.3s ease';
  }

  // Newsletter form feedback
  var form = document.getElementById('newsletter-form');
  if (form) {
    form.addEventListener('submit', function() {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        setTimeout(function() {
          btn.textContent = "You're in ✓";
          btn.style.background = '#7a6230';
        }, 300);
      }
    });
  }
});
